'use client';

import { useTranslation } from '@/i18n/client';

import styles from './ComplianceFooter.module.scss';

export function ComplianceFooter() {
  const { t } = useTranslation(['footer']);

  return (
    <>
      <div className={styles.footer__bottomSection}>
        <div className={styles.footer__bottomSection__wrapper}>
          <div className="container">
            <p className={styles['footer__bottomSection__wrapper--label']}>
              {t('bottomFooter.rights', {
                company: 'Finesio',
                date: new Date().getFullYear(),
              })}
              {['staging', 'local', 'development'].includes(
                process.env.NEXT_PUBLIC_ENVIRONMENT || ''
              ) ? (
                <>
                  <br />
                  <strong>
                    {process.env.NEXT_PUBLIC_BUILD_BRANCH}:{' '}
                    {process.env.NEXT_PUBLIC_BUILD_COMMIT_HASH}
                  </strong>
                  <br />
                </>
              ) : null}
            </p>
          </div>
        </div>
      </div>
    </>
  );
}
